import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateWhatsApp = ({ height = 256, width = 256, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 256 256"
    data-test="whats-app-empty-state"
    {...props}
  >
    <g filter="url(#filter0_ddd_8186_207463)">
      <rect
        x="82"
        y="41"
        width="92"
        height="172"
        rx="8"
        fill="url(#paint0_linear_8186_207463)"
        shapeRendering="crispEdges"
      />
      <rect
        x="82"
        y="41"
        width="92"
        height="172"
        rx="8"
        stroke="white"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        shapeRendering="crispEdges"
      />
      <g filter="url(#filter1_i_8186_207463)">
        <rect x="84" y="43" width="88" height="168" rx="6" fill="url(#paint1_linear_8186_207463)" />
      </g>
      <rect
        x="84.25"
        y="43.25"
        width="87.5"
        height="167.5"
        rx="5.75"
        stroke="#EEECED"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M112 53C112 51.8954 112.895 51 114 51H142C143.105 51 144 51.8954 144 53C144 54.1046 143.105 55 142 55H114C112.895 55 112 54.1046 112 53Z"
        fill="#E0DEDF"
      />
      <path
        d="M90 131C90 128.791 91.7909 127 94 127H124C126.209 127 128 128.791 128 131V171C128 173.209 126.209 175 124 175H94C91.7909 175 90 173.209 90 171V131Z"
        fill="url(#paint2_linear_8186_207463)"
      />
      <path d="M104 157H128H104Z" fill="#CCC8CA" />
      <path
        d="M104 157H128"
        stroke="#CCC8CA"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M104 145H128H104Z" fill="#CCC8CA" />
      <path
        d="M104 145H128"
        stroke="#CCC8CA"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M166 131.32C166 128.934 164.066 127 161.68 127H133.32C130.934 127 129 128.934 129 131.32V170.68C129 173.066 130.934 175 133.32 175H161.68C164.066 175 166 173.066 166 170.68V131.32Z"
        fill="url(#paint3_linear_8186_207463)"
      />
      <path
        d="M154 157H130"
        stroke="#999094"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M154 145H130"
        stroke="#999094"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M130 71.32C130 68.9341 131.934 67 134.32 67H161.68C164.066 67 166 68.9341 166 71.32V110.68C166 113.066 164.066 115 161.68 115H134.32C131.934 115 130 113.066 130 110.68V71.32Z"
        fill="url(#paint4_linear_8186_207463)"
      />
      <path
        d="M126 115L137.377 99.7125C137.981 98.8735 138.778 98.1897 139.701 97.7179C140.625 97.2461 141.649 97 142.687 97C143.726 97 144.75 97.2461 145.673 97.7179C146.597 98.1897 147.394 98.8735 147.998 99.7125L159 115"
        fill="#59C1A7"
      />
      <path
        d="M143.832 83.3802C143.832 85.2588 144.578 87.0605 145.905 88.3889C147.232 89.7173 149.032 90.4635 150.909 90.4635C152.786 90.4635 154.586 89.7173 155.913 88.3889C157.24 87.0605 157.986 85.2588 157.986 83.3802C157.986 81.5016 157.24 79.6999 155.913 78.3715C154.586 77.0432 152.786 76.2969 150.909 76.2969C149.032 76.2969 147.232 77.0432 145.905 78.3715C144.578 79.6999 143.832 81.5016 143.832 83.3802Z"
        fill="#F2CA1B"
      />
      <path
        d="M90 71C90 68.7909 91.7909 67 94 67H124C126.209 67 128 68.7909 128 71V111C128 113.209 126.209 115 124 115H94C91.7909 115 90 113.209 90 111V71Z"
        fill="url(#paint5_linear_8186_207463)"
      />
      <path
        d="M104 115L118.678 96.5189C119.3 95.7368 120.106 95.102 121.032 94.6648C121.959 94.2276 122.98 94 124.016 94C125.052 94 126.073 94.2276 127 94.6648C127 96.2831 127 95.3831 127 96.5189V115H104Z"
        fill="#CCC8CA"
      />
      <g filter="url(#filter2_ddd_8186_207463)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M132 44.9297C134.391 43.5465 136 40.9611 136 38C136 33.5817 132.418 30 128 30C123.582 30 120 33.5817 120 38C120 40.9611 121.609 43.5465 124 44.9297V210.07C121.609 211.453 120 214.039 120 217C120 221.418 123.582 225 128 225C132.418 225 136 221.418 136 217C136 214.039 134.391 211.453 132 210.07V44.9297Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_ddd_8186_207463"
        x="59"
        y="20"
        width="138"
        height="235"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_8186_207463"
          result="effect2_dropShadow_8186_207463"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_8186_207463"
          result="effect3_dropShadow_8186_207463"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_8186_207463"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_i_8186_207463"
        x="84"
        y="43"
        width="88"
        height="168"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8186_207463" />
      </filter>
      <filter
        id="filter2_ddd_8186_207463"
        x="100"
        y="20"
        width="56"
        height="235"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8186_207463" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_8186_207463"
          result="effect2_dropShadow_8186_207463"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_8186_207463"
          result="effect3_dropShadow_8186_207463"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_8186_207463"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_8186_207463"
        x1="174"
        y1="127"
        x2="82"
        y2="127"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" stopColor="#FAFAFA" />
        <stop offset="0.51" stopColor="#F5F4F4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_8186_207463"
        x1="172"
        y1="127"
        x2="84"
        y2="127"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" stopColor="#FAFAFA" />
        <stop offset="0.51" stopColor="#F5F4F4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_8186_207463"
        x1="90"
        y1="151"
        x2="128"
        y2="151"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.655005" stopColor="#EEECED" />
        <stop offset="1" stopColor="#EBE9E9" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_8186_207463"
        x1="166"
        y1="151"
        x2="129"
        y2="151"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.467152" stopColor="white" />
        <stop offset="0.77" stopColor="#F7F7F7" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_8186_207463"
        x1="166"
        y1="91"
        x2="130"
        y2="91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.219319" stopColor="#E6FBFF" />
        <stop offset="1" stopColor="#C2F2FB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_8186_207463"
        x1="90"
        y1="91"
        x2="128"
        y2="91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.655005" stopColor="#EEECED" />
        <stop offset="1" stopColor="#EBE9E9" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
